function ClinicService($q, BBModel) {
    'ngInject';

    return {
        query(params) {
            const {company} = params;
            const defer = $q.defer();
            if (params.id) { // request for a single one
                company.$get('clinics', params).then((clinic) => {
                        clinic = new BBModel.Clinic(clinic);
                        return defer.resolve(clinic);
                    }
                    , err => defer.reject(err));
            } else {
                company.$get('clinics', params).then(collection =>
                        collection.$get('clinics').then((clinics) => {
                                clinics = (Array.from(clinics).map(s => new BBModel.Clinic(s)));
                                return defer.resolve(clinics);
                            }
                            , err => defer.reject(err))

                    , err => defer.reject(err));
            }
            return defer.promise;
        }
    };
}

angular
    .module('BB')
    .service('ClinicService', ClinicService);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/clinic.service.js